import $ from "jquery";
import logger from "../common/Logger"
import ConfigService, {ConfigConstants} from "./ConfigService";
import CoreService from "./CoreService";
import AuthService from "./AuthService";

class ApiService {
    static initialised = false;

    static initialise() {
        ApiService.initialised = true;

        $.ajaxSetup({
            'beforeSend'(xhr) {
                const userToken = AuthService.getToken();
                if (userToken) {
                    xhr.setRequestHeader('Authorization', `Bearer ${userToken}`);
                }
            }
        });

        $(document).ajaxStart(function (event, jqxhr) {
            CoreService.showLoadingModal();
        });

        $(document).ajaxComplete(function (event, jqxhr) {
            CoreService.hideLoadingModal();
        });

        $(document).ajaxError(function (event, jqxhr, config) {
            logger.error(`AJAX error - status code ${jqxhr.status} for ${config.url}`);
            if (jqxhr.status === 401) {
                CoreService.navigateToUnauthenticated();
            }
        });
    }

    static makeRequest(url, options) {
        if (!ApiService.initialised) {
            ApiService.initialise();
        }

        ConfigService.getItem(ConfigConstants.apiBaseUrl, (apiBaseUrl) => {
            logger.debug(`Firing request to ${url}`);
            $.ajax(apiBaseUrl + url, options);
        });
    }
}

export default ApiService;



// WEBPACK FOOTER //
// ./src/modules/service/ApiService.js